"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = FeesableDialog;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const react_1 = require("react");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const DownloadForOffline_1 = __importDefault(require("@mui/icons-material/DownloadForOffline"));
const styles_1 = require("@mui/material/styles");
const icons_material_1 = require("@mui/icons-material");
const html_to_image_1 = require("html-to-image");
const StyledCloseButton = (0, styles_1.styled)(material_1.IconButton)(({ theme }) => ({
    position: 'absolute',
    right: theme.spacing(1),
    top: 12,
    color: theme.palette.primary.contrastText,
}));
const StyledDownloadButton = (0, styles_1.styled)(material_1.IconButton)(({ theme }) => ({
    position: 'absolute',
    right: 46,
    top: 12,
    color: (0, styles_1.alpha)(theme.palette.primary.contrastText, 0.2),
    '&:hover': {
        color: theme.palette.primary.contrastText,
    },
}));
function FeesableDialog(props) {
    const theme = (0, material_1.useTheme)();
    const { onCloseModal } = props;
    const size = props.size || 'md';
    const fullScreen = (0, useMediaQuery_1.default)(theme.breakpoints.down(size));
    const refDl = (0, react_1.useRef)(null);
    const handleScreenshotClick = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () {
        if (refDl.current === null)
            return;
        const filter = (node) => { var _a; return !((_a = node.classList) === null || _a === void 0 ? void 0 : _a.contains('hide-from-download')); };
        try {
            const screenshotUrl = yield (0, html_to_image_1.toPng)(refDl.current, {
                cacheBust: true,
                backgroundColor: '#ffffff',
                filter,
            });
            const link = document.createElement('a');
            link.download = `${props.downloadButtonFilename}.png`;
            link.href = screenshotUrl;
            link.click();
        }
        catch (error) {
            console.error(error);
        }
    }), [refDl]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Dialog, { maxWidth: size, fullWidth: true, fullScreen: fullScreen, open: props.open, onClose: onCloseModal, "aria-labelledby": "breakdown-dialog", className: "breakdown-dialog", children: [(0, jsx_runtime_1.jsxs)("div", { ref: refDl, children: [props.modalTitle && ((0, jsx_runtime_1.jsxs)(material_1.DialogTitle, { id: "breakdown-dialog", sx: {
                            backgroundColor: 'primary.main',
                            color: `${theme.palette.primary.contrastText} !important`,
                        }, children: [props.modalTitle, (0, jsx_runtime_1.jsx)(StyledCloseButton, { "aria-label": "close", onClick: onCloseModal, children: (0, jsx_runtime_1.jsx)(Close_1.default, {}) }), props.downloadButtonFilename && ((0, jsx_runtime_1.jsx)(StyledDownloadButton, { onClick: handleScreenshotClick, className: "hide-from-download", children: (0, jsx_runtime_1.jsx)(DownloadForOffline_1.default, {}) }))] })), props.children] }), props.isSmallScreen && ((0, jsx_runtime_1.jsxs)(material_1.DialogActions, { sx: { justifyContent: 'space-between' }, children: [(0, jsx_runtime_1.jsx)(material_1.Box, { children: props.onPrev ? ((0, jsx_runtime_1.jsx)(material_1.IconButton, { onClick: props.onPrev, children: (0, jsx_runtime_1.jsx)(icons_material_1.ArrowBackIosOutlined, { sx: { color: '#86868B', fontSize: 'inherit' } }) })) : ((0, jsx_runtime_1.jsx)(material_1.IconButton, {})) }), (0, jsx_runtime_1.jsx)(material_1.Box, { children: props.onNext ? ((0, jsx_runtime_1.jsx)(material_1.IconButton, { onClick: props.onNext, color: "inherit", children: (0, jsx_runtime_1.jsx)(icons_material_1.ArrowForwardIosOutlined, { sx: { color: '#86868B', fontSize: 'inherit' } }) })) : ((0, jsx_runtime_1.jsx)(material_1.IconButton, {})) })] }))] }));
}
